import script from "./HeroComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroComponent.vue?vue&type=script&setup=true&lang=js"

import "./HeroComponent.vue?vue&type=style&index=0&id=6c9f8fe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9f8fe8"]])

export default __exports__